import { MUTED } from './muted';

export const FOREGROUND = {
  foreground: MUTED.muted50,
  foregroundAlt: MUTED.muted500,
};
